import type { ComponentSchema } from "../../../../../schema-types"

export const schema: ComponentSchema = {
  type: 'categories',
  label: 'Categories Page Section',
  description: 'The main grid listing all categories.',
  supportedPages: ['categories'],
  variants: [{ id: 'v1', label: 'V1 (Exploration Grid)' }],
  commonFields: [
    { key: 'title', label: 'Section Title', type: 'string' },
    { key: 'subtitle', label: 'Subtitle', type: 'string' },
    {
      key: 'columns',
      label: 'Grid Columns',
      type: 'select',
      options: [
        { label: '2 Columns', value: 2 },
        { label: '3 Columns', value: 3 },
        { label: '4 Columns', value: 4 },
      ],
      default: 4,
    },
    { key: 'emptyText', label: 'Empty State Text', type: 'string', default: 'No categories found.' },
  ],
}
